import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Principles from './../../components/Principles';
export const _frontmatter = {
  "title": "About",
  "slug": "about",
  "cover": "./mountains.jpg"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{` Hi, my name is Brett and I'm a full-stack software developer with a passion for exploring all avenues of creativity and design. While my primary focus as a designer is Web and User-Interface design, as it relates most to my role as a developer, I also enjoy expanding my illustration and 3D modeling capabilities.`}</p>
    <Principles mdxType="Principles" />

    </MDXLayout>;
}
MDXContent.isMDXComponent = true;
      